<script setup lang="ts">
interface Props {
  image?: string | null
}

const props = defineProps<Props>()
useSeoImage({ imagePath: props.image })
</script>

<template>
  <div class="relative">
    <div v-if="!!$slots.navPages">
      <slot name="navPages" />
    </div>
    <div
      :class="{ 'quarter-circle': !props.image }"
      class="relative border-t"
    >
      <div
        v-if="!!$slots.breadcrumb"
        class="container hidden md:block"
      >
        <slot name="breadcrumb" />
      </div>
      <div class="container flex flex-col justify-between gap-12 lg:flex-row">
        <transition
          name="fade"
          mode="out-in"
        >
          <div
            :key="$route.path"
            class="lg:w-7/12"
          >
            <div class="max-w-prose space-y-6 py-8 lg:pb-20 lg:pt-12">
              <div class="space-y-4">
                <p
                  v-if="!!$slots.suptitle"
                  class="relative pb-4 text-pink-500 after:absolute after:bottom-0 after:block after:h-1 after:w-20 after:bg-pink-500 after:content-[''] lg:mb-8"
                >
                  <slot name="suptitle" />
                </p>
                <h1
                  v-if="!!$slots.title"
                  class="text-3xl font-semibold lg:text-5xl"
                >
                  <slot name="title" />
                </h1>
              </div>
              <h2
                v-if="!!$slots.subtitle"
                class="lg:text-lg"
              >
                <slot name="subtitle" />
              </h2>
              <slot />
            </div>
          </div>
        </transition>

        <transition
          name="slide-up-light"
          mode="out-in"
        >
          <div
            v-if="!!props.image"
            :key="props.image"
            class="hidden lg:block lg:w-5/12 lg:rounded-lg lg:bg-cover"
            :data-twic-background="`url('image:${props.image}')`"
            data-twic-step="50"
          />
        </transition>
      </div>
    </div>
  </div>
</template>
